module.exports = __webpack_public_path__ + "static/media/1006130.2c7462d0.png";